/* eslint-disable @typescript-eslint/no-explicit-any */
export default (object: Record<string, any>) => {
  return object ? Object.keys(object).map((item) => object[item]) : [];
};
